var journalist = "https://shopfront-cdn.tekoapis.com/static/fd30b8db36d9b1e3.svg";

export { journalist as default };
